function initTouchClass() {
    window.addEventListener('touchstart', function onFirstTouch(e) {
        $('body').addClass('touch');
        // we only need to know once that a human touched the screen, so we can stop listening now
        window.removeEventListener('touchstart', onFirstTouch, false);
        return true;
    }, false);
}